exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lateral-sliding[data-v-098ffdd7]{display:flex;overflow-y:hidden;overflow-x:visible}.lateral-sliding[data-v-098ffdd7] ::-webkit-scrollbar{display:none}.lateral-sliding-item[data-v-098ffdd7]{display:flex}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-098ffdd7","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/slider/slider.vue
// module id = 52
// module chunks = 0